<template>
  <v-row style="min-height: 100vh">
    <v-col
      md="12"
      sm="12"
      style="
        
          background: rgba(0,167,228,1.000);
          background: -moz-linear-gradient(-45deg, rgba(0,167,228,1.000) 0%, rgba(0,167,228,1.000) 50%, rgba(203,20,38,1) 50%, rgba(203,20,38,1) 100%);
          background: -webkit-gradient(left top, right bottom, color-stop(0%, rgba(0,167,228,1.000)), color-stop(50%, rgba(0,167,228,1.000)), color-stop(50%, rgba(203,20,38,1)), color-stop(100%, rgba(203,20,38,1)));
          background: -webkit-linear-gradient(-45deg, rgba(0,167,228,1.000) 0%, rgba(0,167,228,1.000) 50%, rgba(203,20,38,1) 50%, rgba(203,20,38,1) 100%);
          background: -o-linear-gradient(-45deg, rgba(0,167,228,1.000) 0%, rgba(0,167,228,1.000) 50%, rgba(203,20,38,1) 50%, rgba(203,20,38,1) 100%);
          background: -ms-linear-gradient(-45deg, rgba(0,167,228,1.000) 0%, rgba(0,167,228,1.000) 50%, rgba(203,20,38,1) 50%, rgba(203,20,38,1) 100%);
          background: linear-gradient(135deg, rgba(0,167,228,1.000) 0%, rgba(0,167,228,1.000) 50%, rgba(203,20,38,1) 50%, rgba(203,20,38,1) 100%);
          filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#133b7d', endColorstr='#cb1426', GradientType=1 );
        "
    >
      <div>
        <div class="logo-container">
          <img
            src="@/assets/interwhite.svg"
            style="width: 17%; margin-bottom: 5%;"
          />
        </div>
        <div style="min-width: 60% ">
          <div class="login-box-container">
            <div class="login-box">
              <v-card
                :loading="loadingScreen"
                elevation="4"
                outlined
                shaped
                style="width: 100%"
              >
                <div
                  v-if="loadingScreen"
                  style="text-align:center; padding: 50px;"
                >
                  <v-progress-circular
                    indeterminate
                    color="primary"
                    size="64"
                  ></v-progress-circular>
                </div>
                <!--  -->
                <div style="padding: 30px" v-else-if="valid">
                  <div style="text-align: center; padding-bottom: 30px;">
                    <h1>Restablecer contraseña</h1>
                    Introduce tu nueva contraseña
                  </div>
                  <v-form ref="form" @submit.prevent="submitForm">
                    <h4>
                      Contraseña
                    </h4>
                    <v-text-field
                      v-model="password"
                      :rules="passwordFieldRules"
                      required
                      :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                      :type="show1 ? 'text' : 'password'"
                      name="input-10-1"
                      counter
                      @click:append="show1 = !show1"
                    ></v-text-field>

                    <h4>Confirma la contraseña</h4>
                    <v-text-field
                      v-model="confirmPassword"
                      :rules="confirmPasswordRules"
                      required
                      :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                      :type="show1 ? 'text' : 'password'"
                      name="input-10-1"
                      counter
                      @click:append="show1 = !show1"
                    ></v-text-field>

                    <div class="text-caption mt-2">
                      <div class="d-flex align-center">
                        <v-icon
                          :color="passwordChecks.min ? 'green' : 'red'"
                          small
                        >
                          {{ passwordChecks.min ? "mdi-check" : "mdi-close" }}
                        </v-icon>
                        <span class="ml-2"
                          >Debe tener al menos 6 caracteres</span
                        >
                      </div>

                      <div class="d-flex align-center">
                        <v-icon
                          :color="passwordChecks.upper ? 'green' : 'red'"
                          small
                        >
                          {{ passwordChecks.upper ? "mdi-check" : "mdi-close" }}
                        </v-icon>
                        <span class="ml-2"
                          >Debe incluir una letra mayúscula</span
                        >
                      </div>

                      <div class="d-flex align-center">
                        <v-icon
                          :color="passwordChecks.special ? 'green' : 'red'"
                          small
                        >
                          {{
                            passwordChecks.special ? "mdi-check" : "mdi-close"
                          }}
                        </v-icon>
                        <span class="ml-2"
                          >Debe incluir un número y un carácter especial</span
                        >
                      </div>
                    </div>

                    <div style="text-align: end !important;">
                      <v-btn
                        color="success"
                        class="mr-4"
                        type="submit"
                        :loading="loading"
                        :disabled="!canContinue || disabledAfterSuccess"
                        style="margin-top: 20px;"
                      >
                        Continuar
                      </v-btn>
                    </div>
                  </v-form>
                </div>
                <!--  -->
                <div v-else>
                  <div style="text-align: center; padding: 30px;">
                    <h2>{{ invalid.title }}</h2>
                    <p style="margin-top: 15px;">{{ invalid.msg }}</p>

                    <v-btn color="success" class="mt-6" @click="goBack()">
                      Recuperar contraseña
                    </v-btn>
                  </div>
                </div>
              </v-card>
            </div>
          </div>
        </div>
      </div>
      <div
        class="bradescard-container"
        style=" text-align: end;
            float: none;
            position: absolute;
            right: 0;
            width:23%;
            bottom: 0;
            padding-bottom: 20px;
            padding-right: 1%;
        "
      >
        <img
          src="@/assets/BRADESCARD_logo_BCO.png"
          class="bradescard-logo"
        />
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { mainAxios } from "@/mainAxios";
export default {
  data() {
    return {
      password: "",
      confirmPassword: "",
      loading: false,
      loadingScreen: true,
      valid: false,
      disabledAfterSuccess: false,
      invalid: {
        title: "",
        msg: "",
      },
    };
  },
  mounted() {
    this.checkValidity();
  },
  methods: {
    async submitForm() {
      this.loading = true;
      try {
        const uuid = this.$route.params.uuid;
        const body = {
          uuid: uuid,
          password: this.password,
        };

        const res = await mainAxios.post("/v1/password/recovery/update", body);
        this.$toast.success(res.data.message);

        // Deshabilita boton de guardar y espera 5 segundos para redirigir a login
        this.disabledAfterSuccess = true;
        setTimeout(() => {
          this.$router.push("/");
        }, 5000);
      } catch (ex) {
        this.$toast.error(ex.response.data.message);
      } finally {
        this.loading = false;
      }
    },

    goBack() {
      this.$router.push("/cambio-contrasenia");
    },

    // Verifica que la caducidad sea valida y no se haya usado ya esta peticion de cambio
    async checkValidity() {
      this.loadingScreen = true;
      try {
        const uuid = this.$route.params.uuid;
        const body = { uuid };

        const res = await mainAxios.post("/v1/password/recovery/active", body);

        if (res.data.status === 200) {
          this.valid = true;
        }
      } catch (err) {
        const error_api = err.response?.data;

        if (error_api?.code === 100) {
          this.invalid.title = "Recuperación de contraseña utilizada";
          this.invalid.msg =
            "La liga de recuperación de contraseña ya fue utilizada y no puede volver a usarse, si haz olvidado tu contraseña haz clic al botón de Recuperar contraseña";
        } else if (error_api?.code === 101) {
          this.invalid.title = "Restablecer contraseña expirada";
          this.invalid.msg =
            "La liga de recuperación de contraseña ha expirado por lo que será necesario volver a realizar la solicitud nuevamente.";
        } else {
          this.invalid.title = "Error inesperado";
          this.invalid.msg =
            error_api?.message || "Ocurrió un error al validar la liga.";
        }
      } finally {
        this.loadingScreen = false;
      }
    },
  },
  computed: {
    passwordFieldRules() {
      return [
        (v) => !!v || "La contraseña es requerida",
        (v) => v.length >= 6 || "Debe tener al menos 6 caracteres",
        (v) => /[A-Z]/.test(v) || "Debe incluir una letra mayúscula",
        (v) =>
          (/[0-9]/.test(v) && /[^A-Za-z0-9]/.test(v)) ||
          "Debe incluir un número y un carácter especial",
      ];
    },
    confirmPasswordRules() {
      return [
        (v) => !!v || "La confirmación es requerida",
        (v) => v === this.password || "Las contraseñas no coinciden",
      ];
    },
    passwordChecks() {
      return {
        min: this.password.length >= 6,
        upper: /[A-Z]/.test(this.password),
        special:
          /[0-9]/.test(this.password) && /[^A-Za-z0-9]/.test(this.password),
      };
    },
    canContinue() {
      return (
        this.password === this.confirmPassword &&
        this.passwordChecks.min &&
        this.passwordChecks.upper &&
        this.passwordChecks.special
      );
    },
  },
};
</script>

<style scoped>
@media (max-width: 992px) {
  .segurify-logo {
    width: 17%;
    padding-bottom: 5%;
  }
  .logo-container {
    text-align: center !important;
  }
  .login-box {
    padding-left: 0% !important;
    padding-right: 0% !important;
  }
  .bradescard-logo {
    width: 50% !important;
  }
  .bradescard-container {
    text-align: center !important;
  }
}
.logo-container {
  text-align: inherit;
}
.login-box {
  width: 30%;
}
.login-box-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 50vh;
}

.bradescard-logo {
  width: 100%;
}
.bradescard-container {
  text-align: end;
}

.v-application .success {
  background-color: #133b7d !important;
  border-color: #133b7d !important;
}
.password-rules {
  font-size: 12px; /* o 0.8rem */
  color: #555; /* grisito */
  margin-top: 10px;
  line-height: 1.4;
}
</style>
